export default class DashboardHeader {

	static selector = 'dashboard-header';

	el = {};

	constructor(container) {
		this.el = {
			container
		};
	}

}
